module.exports = __webpack_public_path__ + "static/media/clickup.cad5c15e.svg";